module.exports = __webpack_public_path__ + "static/media/s1.27983674.png";